import { update } from 'ramda';
import Vue from 'vue';
import { parsePayloadJobs, parseResponseJobs } from '@/modules/polls/utils/custom/job-evaluation';
import helper from '@/shared/helper';

const { getLocalData } = helper;

export default {
	updateSelectedJob({ commit }, payload) {
		commit('UPDATE_SELECTED_JOB', payload);
	},
	updateJob({ commit, state }, { job, index }) {
		commit('UPDATE_JOBS', update(index, job, state.custom.jobEvaluationPoll.jobs));
		commit('UPDATE_SELECTED_JOB', job);
	},
	async getSurveyData({ commit }, { surveyId }) {
		try {
			const { data: { jobs = [], diagnosticId, id, commitee: { configRelation } } } = await Vue.prototype.$http.get(`/poll-employees/${surveyId}/detail`);
			const jobsFilter = jobs.filter(job => configRelation.jobs.includes(job.id));
			commit('UPDATE_JOBS', parseResponseJobs(jobsFilter));
			commit('UPDATE_DIAGNOSTIC_ID', diagnosticId);
			commit('UPDATE_POLL_ID', id);
			return true;
		} catch (e) {
			throw e;
		}
	},
	async saveSurveyData({ state }, { isFinalSave }) {
		const { jobs, diagnosticId, pollId } = state.custom.jobEvaluationPoll;
		const param = isFinalSave ? '?finalSave=true' : '';
		const employeeId = getLocalData('praktiko-user').id;
		try {
			await Vue.prototype.$http.post(`/poll-employees/unique/${diagnosticId}/${pollId}/${employeeId}${param}`, parsePayloadJobs(jobs));
		} catch (e) {
			throw e;
		}
	},
};



// WEBPACK FOOTER //
// ./src/modules/polls/store/custom/job-evaluation-poll/actions.js